// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContextMenu-module-menu {
  border-radius: 5px;
  box-shadow: var(--box-shadow-default);
  overflow: hidden;
  position: relative;
  bottom: 0;
  width: calc(100% - 25px);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: var(--background);
  z-index: 2;
  margin-top: 5px;
}

.ContextMenu-module-menu > ul {
  padding: 5px;
  margin: 0;
  list-style: none;
}

.ContextMenu-module-menu button {
  width: 100%;
  text-align: left;
  border-radius: 5px;
  font-weight: 300;
  cursor: initial;
  background-color: var(--background);
  color: var(--text);
  box-shadow: none;
}

.ContextMenu-module-menuContainer {
  display: none;
}

.ContextMenu-module-menuContainer.ContextMenu-module-open {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  background-color: rgba(47, 47, 47, 0.679);
  backdrop-filter: blur(5px);
  width: 100%;
  justify-content: center;
  align-items: flex-end;
}

@media screen and (min-width: 720px) {
  
  .ContextMenu-module-menu {
    bottom: initial;
    position: relative;
    width: 100%;
    border: 1px solid var(--border);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .ContextMenu-module-menuContainer.ContextMenu-module-open {
    background-color: transparent;
    backdrop-filter: none;
    top: initial;
    left: initial;
    height: initial;
    width: initial;
    justify-content: initial;
    align-items: initial;
  }

  .ContextMenu-module-menu button:hover {
    box-shadow: var(--box-shadow-default);
  }

}`, "",{"version":3,"sources":["webpack://./src/components/ContextMenu/ContextMenu.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;EACnC,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,UAAU;EACV,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,0BAA0B;EAC1B,WAAW;EACX,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;EAEE;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,+BAA+B;IAC/B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,cAAc;IACd,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;EACvC;;AAEF","sourcesContent":[".menu {\n  border-radius: 5px;\n  box-shadow: var(--box-shadow-default);\n  overflow: hidden;\n  position: relative;\n  bottom: 0;\n  width: calc(100% - 25px);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  background-color: var(--background);\n  z-index: 2;\n  margin-top: 5px;\n}\n\n.menu > ul {\n  padding: 5px;\n  margin: 0;\n  list-style: none;\n}\n\n.menu button {\n  width: 100%;\n  text-align: left;\n  border-radius: 5px;\n  font-weight: 300;\n  cursor: initial;\n  background-color: var(--background);\n  color: var(--text);\n  box-shadow: none;\n}\n\n.menuContainer {\n  display: none;\n}\n\n.menuContainer.open {\n  position: fixed;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  height: 100%;\n  display: flex;\n  background-color: rgba(47, 47, 47, 0.679);\n  backdrop-filter: blur(5px);\n  width: 100%;\n  justify-content: center;\n  align-items: flex-end;\n}\n\n@media screen and (min-width: 720px) {\n  \n  .menu {\n    bottom: initial;\n    position: relative;\n    width: 100%;\n    border: 1px solid var(--border);\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n  }\n\n  .menuContainer.open {\n    background-color: transparent;\n    backdrop-filter: none;\n    top: initial;\n    left: initial;\n    height: initial;\n    width: initial;\n    justify-content: initial;\n    align-items: initial;\n  }\n\n  .menu button:hover {\n    box-shadow: var(--box-shadow-default);\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `ContextMenu-module-menu`,
	"menuContainer": `ContextMenu-module-menuContainer`,
	"open": `ContextMenu-module-open`
};
export default ___CSS_LOADER_EXPORT___;
